export const Income = {
  "years": [
    'S',
    'M',
    'T',
    'W',
    'T',
    'F',
    'S'
  ],
  "data": {
    "sales": [25, 28, 20, 15,25, 28, 20],
  }
};

export const Customers = {
  "years": [
    'S',
    'M',
    'T',
    'W',
    'T',
    'F',
    'S'
  ],
  "data": {
    "sales": [10, 20, 30, 15,20, 30, 15],
  }
}
export const Sales = {
  "years": [
    'S',
    'M',
    'T',
    'W',
    'T',
    'F',
    'S'
  ],
  "data": {
    "sales": [13, 8, 10, 15,15,20, 18],
  }
}
export const Tickets = {
  "years": [
    'S',
    'M',
    'T',
    'W',
    'T',
    'F',
    'S'
  ],
  "data": {
    "sales": [12, 18, 7, 15, 8, 10, 15],
  }
}

export const Big = {
  "years": ["2020", "2021", "2022", "2020", "2021", "2022", "2020", "2021", "2022"],
  "data": {
    "sales": [12, 18, 7, 12, 18, 7, 4, 8, 13],
  }
}
export const MonthlySale = {
  months: ["week 1", "week 2", "week 3", "week 4"],
  data: {
    gain: [0, 6, 2, 8],
    lost: [12, 10, 5, 15],
  }
};

export const FirstChart = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  data: {
    publish: [15, 15, 19, 19, 14, 14, 10, 10, 15, 15, 18, 18],
  }
}